import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchDashboardData, fetchFavProducts, fetchFilteredByStockProducts } from "../../store/reducers/createProfile/apithunk";
import { ToastNotifyError } from "../../components/CommonComponents/Toast/ToastNotify";
import rollbar from "../../rollbarConfig";

export function useDashboard() {
const [lowInStockProductsLoading, setInStockProductsLoadingIsLoading] = useState(true);
const [lowInStockProducts, setlowInStockProducts] = useState([]);
const [favData, setFavData] = useState([]);
const [favDataLoading, setFavDataLoading] = useState(true);
const [dashboardData, setDashboardData] = useState([]);
const [dashboardDataLoading, setDashboardDataLoading] = useState(true);
const dispatch = useDispatch();

  const searchLowInStockProducts = async () => {
    setInStockProductsLoadingIsLoading(true);
    try {
      const response = await dispatch(fetchFilteredByStockProducts("low_stock"));
      const { status, data } = response.payload;

      if (status) {
        setlowInStockProducts(data)
      } 
    } catch (error) {
      rollbar.error("Error message", error);
      console.error("Error fetching products:", error);
    } finally {
        setInStockProductsLoadingIsLoading(false);
    }
  };


    const fetchFavouriteData = async () => {
      setFavDataLoading(true);
      try {
        const res = await dispatch(fetchFavProducts("?page_size=5"));
        const { data, status, message } = res?.payload;
        if (status) {
          setFavData(data);
        } else {
          ToastNotifyError(message);
        }
      } catch (error) {
        console.error("Favorite get api failed:", error);
        rollbar.error("Error message", error);
      } finally {
        setFavDataLoading(false);
      }
    };

    const fetchSellerDashboardData = async () => {
      setDashboardDataLoading(true);
      try {
        const res = await dispatch(fetchDashboardData());
        const { data, status, message } = res.payload
      
        if (status === 200) {
          setDashboardData(data);
        } else {
          ToastNotifyError(message);
        }
      } catch (error) {
        rollbar.error("Error message", error);
        console.error("Dashboard get api failed:", error);
      } finally {
        setDashboardDataLoading(false);
      }
    };


  useEffect(() => {
        fetchFavouriteData();
        searchLowInStockProducts();
        fetchSellerDashboardData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    lowInStockProductsLoading,
    lowInStockProducts,
    favData,
    favDataLoading,
    dashboardDataLoading,
    dashboardData
  };
}
